// extracted by mini-css-extract-plugin
export default {"title-wrapper":"SectionHeader_title-wrapper__yAESk","section-title":"SectionHeader_section-title__cn+mT","section-subtitle":"SectionHeader_section-subtitle__Mqu8F"};